import useAuth from "hooks/useAuth";
import Login from "pages/student/login";
import React, { Fragment, useState } from "react";
import { Navigate, useLocation } from "react-router-dom"; // component props interface

const StudentAuthGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isAuthenticated || !user.isStudent) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    // return <Navigate to="/login" />;
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to="/" />;
  }

  return <Fragment>{children}</Fragment>;
};

export default StudentAuthGuard;
